module.exports = __webpack_public_path__ + "static/media/mari_desktop3.f37b30dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mari/mari_desktop3.png
// module id = 92
// module chunks = 0